var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5934\u50CF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F7FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-2",
    cx: 18,
    cy: 18,
    r: 18
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u6570\\u5B57\\u8D44\\u4EA7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 4,
    transform: "translate(-854.000000, -358.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5934\\u50CF",
    transform: "translate(855.110500, 359.121094)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#F5F6F7",
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-38",
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.750000, 6.009075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,20.2869215 L17.5,20.2869215 C20.2614237,20.2869215 22.5,22.5254977 22.5,25.2869215 L22.5,29.6321342 L22.5,29.6321342 L0,29.6321342 L0,25.2869215 C-3.38176876e-16,22.5254977 2.23857625,20.2869215 5,20.2869215 Z",
    id: "\\u8EAB\\u4F53",
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u8033\\u6735",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(3.612712, 8.949580)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#FFA5B4",
    cx: 13.4403992,
    cy: 1.75274762,
    rx: 1.66173706,
    ry: 1.75274762
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD-8",
    fill: "#FFA5B4",
    opacity: 0.993303571,
    cx: 1.66173706,
    cy: 1.75274762,
    rx: 1.66173706,
    ry: 1.75274762
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u8116\\u5B50",
    fill: "#FFA5B4",
    x: 8.31172889,
    y: 16.8338087,
    width: 5.73134766,
    height: 4.56009521
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27444861,5.12051521 L16.0531107,5.12051521 C16.6053955,5.12051521 17.0531107,5.56823046 17.0531107,6.12051521 L17.0531107,12.203401 C17.0531107,15.4559887 14.4163674,18.092732 11.1637797,18.092732 C7.91119194,18.092732 5.27444861,15.4559887 5.27444861,12.203401 L5.27444861,6.12051521 C5.27444861,5.56823046 5.72216386,5.12051521 6.27444861,5.12051521 Z",
    id: "\\u8138",
    fill: "#FFB1BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9245219,3.71316658 C16.9967875,3.27488533 15.0671488,2.32874275 13.1356058,0.874738844 C10.2382914,-1.30626702 4.69678748,0.949665602 4.69678748,3.71316658 C4.69678748,6.47666755 8.72679236,7.46236091 12.5089457,7.46236091 C15.0303812,7.46236091 17.1689066,6.21262947 18.9245219,3.71316658 Z",
    id: "\\u8DEF\\u5F84-11",
    fill: "#231E43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4237894,5.12051521 C17.9151713,5.77669197 18.1608622,6.38657966 18.1608622,6.9501783 C18.1608622,7.79557625 17.4901469,10.3843946 17.2716288,10.3843946 C17.1259501,10.3843946 16.950059,10.3843946 16.7439554,10.3843946 L16.1745341,5.93251472 L17.4237894,5.12051521 Z",
    id: "\\u8DEF\\u5F84-12",
    fill: "#231E43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98364051,4.66886726 C5.64574988,5.62614265 5.97680457,6.38657966 5.97680457,6.9501783 C5.97680457,7.79557625 5.30608924,10.3843946 5.08757117,10.3843946 C4.94189246,10.3843946 4.76600135,10.3843946 4.55989783,10.3843946 L3.94686072,5.65796638 L4.98364051,4.66886726 Z",
    id: "\\u8DEF\\u5F84-12\\u5907\\u4EFD",
    fill: "#231E43",
    transform: "translate(4.961833, 7.526631) scale(-1, 1) translate(-4.961833, -7.526631) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9131449,20.2869215 C7.9131449,20.2869215 8.84544471,23.4019924 10.7100443,29.6321342 L11.8106547,29.6321342 L14.4438578,20.2869215 C10.0900492,20.2869215 7.9131449,20.2869215 7.9131449,20.2869215 Z",
    id: "\\u8863\\u670D",
    fill: "#C8D8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1637797,20.6277174 C11.1618021,20.6277174 10.7583109,21.0515333 9.95330603,21.8991651 L10.7645365,22.4329908 L9.7673075,27.3997999 L11.1608134,28.7402418 L12.5978251,27.2351148 L11.6068583,22.4329908 L12.3022929,21.8991651 C11.5452616,21.0515333 11.1657572,20.6277174 11.1637797,20.6277174 Z",
    id: "\\u9886\\u5E26",
    fill: "#0088FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u9886\\u5B50",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(6.813633, 19.048213)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-13",
    fill: "#FFFFFF",
    points: "4.43636682 1.49677734 7.22944336 0 8.69436035 0.947131348 6.32120361 4.29741211"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84-13\\u5907\\u4EFD",
    fill: "#FFFFFF",
    transform: "translate(2.218183, 2.148706) scale(-1, 1) translate(-2.218183, -2.148706) ",
    points: "0 1.49677734 2.79307654 0 4.43636682 0.97833252 1.50323694 4.29741211"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarUser);
export default __webpack_public_path__ + "static/media/avatar-user.6a682b81.svg";
export { ForwardRef as ReactComponent };